import {
  CANVAS_HORIZONTAL_PADDING,
  ROW_SPACING,
  CANVAS_VERTICAL_PADDING,
  NODE_WIDTH,
} from 'flow/service/graph';

// show 30px of the island nodes
const DESIRED_VISIBLE_ISLAND_NODE_PXS_WHILE_PEEKING = 30;
export const SIMPLE_ISLAND_PEEKING_RIGHT = -(
  NODE_WIDTH - DESIRED_VISIBLE_ISLAND_NODE_PXS_WHILE_PEEKING);

export const SIMPLE_ISLAND_TOP = CANVAS_VERTICAL_PADDING;

export const SIMPLE_ISLAND_EXPANDED_RIGHT = CANVAS_HORIZONTAL_PADDING;
export const SIMPLE_ISLAND_NODE_SPACING = ROW_SPACING;
export const EXPAND_ANIMATION_TIME = 300;
export const PEEKING_HOVER_TRANSLATE = 20;
